<template>
    <div class="cashWheel">
        <!-- <CustomHeader :text="$t('cashWheel.title')" /> -->
        <div class="wheel_container">
            <div class="top_frame">
                <img src="@/assets/cashwheel/pddv2_top_frame.png" alt="">
                <van-row class="top_middle">
                    <van-col span="10" offset="7" class="cash">
                        {{ formatCurrency(animatedValue) }}
                    </van-col>
                    <van-col span="7" :style="{ opacity: resData.user_pdd_info.current_progress == 0 ? '0.45' : '' }"
                        class="top_btn">
                        <img src="@/assets/cashwheel/pddv2_top_btn.png" alt="" @click="showPayment">
                    </van-col>
                    <van-col span="24">
                        <div class="bar">
                            <div class="progress"
                                :style="{ width: resData.user_pdd_info.current_progress / 100 + '%' }">
                            </div>
                            <div class="progress-end-dot" :style="{ left: `calc(${progressPercentage}% - 6px)` }"></div>
                        </div>
                    </van-col>
                    <van-col span="24" class="top_text">
                        {{ $t('cashWheel.neccessary') }} <span>{{ 5.38 }}</span> {{ $t('cashWheel.makeWithdrawal') }}
                    </van-col>
                </van-row>
            </div>

            <CashWheel @showWinPopup="showWinDetails" />
        </div>
        <div class="timer">
            <span>{{ $t('cashWheel.expireIn') }} <span>{{ formattedTime }}</span></span>
        </div>
        <div class="share_item">
            <img src="@/assets/cashwheel/pddv2_share_item.png" alt="">
        </div>

        <div class="report">
            <img src="@/assets/cashwheel/pddv2_middle_bg.png" alt="">

            <div class="report_table">
                <van-row class="head_table">
                    <van-col span="12">
                        <img v-if="selectedReportType == 0" src="@/assets/cashwheel/pddv2_middle_left.png" alt=""
                            class="headText">
                        <div v-else class="empty_container1" @click="selectReportType(0)"></div>
                    </van-col>
                    <van-col span="12">
                        <img v-if="selectedReportType == 1" src="@/assets/cashwheel/pddv2_middle_right.png" alt=""
                            style="margin: 5px 0 0px -23px;">
                        <div v-else class="empty_container2" @click="selectReportType(1)"></div>
                    </van-col>
                </van-row>
                <ReportData :dataList="assistList.rewards" />
            </div>
        </div>

        <div class="bottom_text">
            <van-row style="padding-bottom: 10px;">
                <van-col span="6" class="">
                    <div class="line1"></div>
                </van-col>
                <van-col span="12" class="title">
                    <div>{{ $t("common.activityTitle") }}</div>
                </van-col>
                <van-col span="6" class="">
                    <div class="line2"></div>
                </van-col>
            </van-row>
            <div class="line_text" v-for="(item, index) in resData.user_pdd_info.activity_intro" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
    <PaymentPopup ref="payementRef" />
    <WinPopup ref="winPopupRef" />
</template>

<script setup lang="ts">
// import CustomHeader from '@/components/common/customHeader.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import CashWheel from './components/cashWheel.vue';
import ReportData from './components/reportData.vue';
import PaymentPopup from './components/paymentPopup.vue';
import WinPopup from './components/winPopup.vue';
const resData = ref({
    can_join: 1,

    user_pdd_info: {
        activity_intro: [
            "1.Você pode começar a sacar dinheiro quando o valor acumulado atingir 100BRL\n",
            "2.Convidar amigos para se registrarem em 688v.com irá ajudá-lo a sacar dinheiro rapidamente.\n",
            "3.Cada usuário receberá uma rodada grátis por dia.\n",
            "4.A atividade de cada usuário é válida por 3 dias e pode participar da atividade várias vezes.\n",
            "5.Se você receber um bônus extra, poderá jogar de graça e ganhar mais dinheiro real.\n",
            "6.Se nenhum saque for feito dentro de 3 dias, os fundos serão perdidos.\n"
        ],
        current_progress: 9452,
        current_target: 10000,
        days: 3,
        draw_count: 1,
        end_time: 1748259494,
        receive_rewards: 0,
        share_link: "https://688v.team/#/cashwheel?a=styk1ngs",
        start_time: 1748000294
    }
});

const assistList = ref({
    assists: [],
    rewards: [
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5569966036826"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5529955672359"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5537992670787"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5534939022762"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5559935934836"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5548966762018"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5529929388973"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5527998799919"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5514912448710"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5575967865248"
        },

        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5543972354561"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5548954560432"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5517935598177"
        },
        {
            coin: 10000,
            content: "Acabou de sacar",
            phone: "5569929029201"
        }
    ]
})
const selectedReportType = ref(0)
const payementRef = ref()
const animatedValue = ref(0)
const endTime = new Date('2025-05-30T18:00:00Z').getTime() // example end time (ms)
const winPopupRef = ref()
const formattedTime = ref('')
const progressPercentage = computed(() => resData.value.user_pdd_info.current_progress / 100);


function formatDuration(ms: number) {
    if (ms <= 0) return '0d 00:00:00'

    const totalSeconds = Math.floor(ms / 1000)
    const days = Math.floor(totalSeconds / (3600 * 24))
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return `${days}d ${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

let timerInterval: number

function updateTimer() {
    const now = Date.now()
    const diff = endTime - now
    formattedTime.value = formatDuration(diff)
    if (diff <= 0 && timerInterval) {
        clearInterval(timerInterval)
    }
}

const showWinDetails = () => {
    winPopupRef.value.open((resData.value))
}
onMounted(() => {
    updateTimer()
    timerInterval = window.setInterval(updateTimer, 1000)
})

onUnmounted(() => {
    clearInterval(timerInterval)
})
const selectReportType = (value: number) => {
    selectedReportType.value = value
}
const showPayment = () => {
    payementRef.value.open(resData.value)
}

const animateValue = (start: number, end: number, duration: number) => {
    const startTime = performance.now()

    const step = (currentTime: number) => {
        const progress = Math.min((currentTime - startTime) / duration, 1)
        animatedValue.value = start + (end - start) * progress

        if (progress < 1) {
            requestAnimationFrame(step)
        } else {
            animatedValue.value = end
        }
    }

    requestAnimationFrame(step)
}

watch(
    () => resData.value.user_pdd_info.current_progress,
    (newVal) => {
        const target = newVal / 100
        animateValue(0, target, 800) // 800ms animation
    },
    { immediate: true }
)
</script>
<style scoped>
.cashWheel {
    font-family: system-ui;
}

.wheel_container {
    padding: 70px 0;

}

.top_frame {
    padding: 0 15px;
    position: relative;
}

.top_frame img {
    width: 100%;
}

.cash {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #F0A853;
    font-weight: bold;
}

.top_middle {
    position: absolute;
    top: 20px;
    left: 25px;
    right: 25px;
}

.bar {
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 8px;
    width: 100%;
    margin: 10px 0;
}

.progress {
    background: #F0A853;
    border-radius: 10px;
    height: 8px;
}

.top_btn {
    padding-right: 15px;
}

.top_text {
    color: rgba(255, 255, 255, 0.65);
    text-align: center;
    font-family: system-ui;
    font-size: 14px;
}

.top_text span {
    color: #F0A853;
    font-weight: bold;
}

.timer {
    position: static;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 345px;
}

.timer span {
    border-radius: 10px;
    padding: 5px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.65);
    background: rgba(0, 0, 0, 0.25);
}

.timer span span {
    color: #FFFFFF;
}

.share_item {
    padding: 10px 25px;
}

.share_item img {
    width: 100%;
}

.report {
    padding: 5px 25px;
    position: relative;
}

.report img {
    width: 100%;
}

.report_table {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
}

.head_table img {
    width: 100%;
}

.headText {
    padding: 5px 24px;
}

.empty_container1 {
    width: 50%;
    height: 70%;
    margin-top: 10px;
    margin-left: 50px;
}

.empty_container2 {
    width: 80%;
    height: 70%;
    margin-top: 10px;
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

.progress-end-dot {
    position: absolute;
    top: 65%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    z-index: 2;
}

@media screen and (max-width: 768px) {
    .timer {
        margin-top: 475px;
    }

    .headText {
        padding: 6px 29px;
    }
}

@media screen and (max-width: 400px) {
    .timer {
        margin-top: 275px;
    }

    .headText {
        padding: 5px 23px;
    }

    .progress-end-dot {
        top: 53%;
    }
}
</style>